/**
 * Phone validation via libphonenumber (intl-tel-input utils)
 *
 * @package DesignSchool\Forms
 */

import intlTelInput from 'intl-tel-input';
import { isValidPhoneE164 } from './phone-utils';

export function isValidPhoneInput(el: HTMLInputElement): boolean {
    const raw = (el.value || '').trim();
    if (!raw || raw === '+') {
        return true;
    }

    const iti = intlTelInput.getInstance(el);
    const utils = (intlTelInput as typeof intlTelInput & { utils?: unknown }).utils;

    const phoneMask =
        typeof window !== 'undefined'
            ? (window as Window & { dsFormsPhoneMask?: { getTelValue?: (input: HTMLInputElement) => string } })
                  .dsFormsPhoneMask
            : undefined;
    const resolved = phoneMask?.getTelValue?.(el) || raw;

    if (iti && utils) {
        try {
            if (iti.isValidNumber()) {
                return true;
            }
        } catch {
            // fallback below
        }
    }

    return isValidPhoneE164(resolved);
}
